import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import setOrigin from './originModeReducer';


const actions = {
  [types.SET_ORIGIN]: setOrigin,
};

const initialState = {
  mode: '',
};

export default (state = initialState, action) => (actions[action.type] || identity)(state, action);
